export default "__VITE_ASSET__JfhIgLRw__"